<template>
  <div class="vc-base-list-item" :class="getListItemClasses" :data-qa="dataQa" @click="onClick()">
    <!-- eslint-disable-next-line vue/no-lone-template -->
    <template>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  name: 'VcBaseListItem',
  model: {
    prop: 'selected',
  },
  props: {
    /**
     * The effect of this class can be seen when the items is in selected mode
     */
    selectedClass: {
      type: String,
      default: 'multiple',
      validator: (selectedClass) => ['multiple', 'single'].includes(selectedClass),
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataQa: {
      type: String,
      default: 'vc-base-list-item',
    },
  },
  computed: {
    getListItemClasses() {
      return {
        [this.selectedClass]: true,
        disabled: this.disabled,
        active: this.selected,
      };
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vc-base-list-item {
  padding: var(--size-value4);
  cursor: pointer;
  transition: background 0.8s;

  &.disabled {
    cursor: unset;
    background-color: var(--gray-lighten-3);
    color: var(--gray-darken-2);
  }

  &:not(.disabled) {
    &:hover {
      background-color: var(--gray-lighten-3);
    }

    &:focus {
      box-shadow: 0 0 0 2px var(--v-secondary-lighten1);

      &:before {
        background-color: var(--modal-bg-color);
      }
    }

    &.active {
      &::before {
        background-color: unset;
      }

      &:not(.disabled) {
        &.multiple {
          background-color: unset;
        }

        &.single {
          background-color: var(--v-secondary-lighten3);
        }
      }
    }

    &:active {
      background-color: var(--gray) !important;
      transition: background 0s;
    }
  }
}
</style>
